<div class="modal-header">
  <h5 class="modal-title">{{ newPartner._id ? "Edit" : "New" }} Partner</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>
<div class="modal-body">
  <form #partnerForm="ngForm">
    <div class="container-fluid">
      <!-- Error Message Display -->
      @if (errorMessage) {
        <div class="alert alert-danger" role="alert">
          {{ errorMessage }}
        </div>
      }

      <div class="row">

        <!-- Name -->
        <div class="col-md-6">
          <div class="form-group">
            <label class="required">Name</label>
            <input type="text" class="form-control" required name="pName" #partnerName="ngModel"
              [(ngModel)]="newPartner.name" required>
          </div>
          @if (partnerName.touched && partnerName.invalid) {
            <div class="text-danger">
              Please enter the name
            </div>
          }
        </div>

        <!-- Type -->
        <div class="col-md-6">
          <div class="form-group">
            <label class="required">Type</label>
            <select class="form-control form-select" name="pType" #pType="ngModel"
              [(ngModel)]="newPartner.type" required>
              <option value="Issuer">Issuer</option>
              <option value="Acquirer">Acquirer</option>
            </select>
          </div>
          @if (pType.touched && pType.invalid) {
            <div class="text-danger">
              Please select type
            </div>
          }
        </div>

        <!-- Services -->
        <div class="col-md-6 mt-3">
          <div class="form-group">
            <label class="required">Services</label>
            <select class="form-control form-select" name="services" #services="ngModel"
              [(ngModel)]="newPartner.services" required>
              <option value="PAYMENT">Payment</option>
              <option value="REMITTANCE">Remittance</option>
              <option value="BOTH">Both</option>
            </select>
          </div>
          @if (services.touched && services.invalid) {
            <div class="text-danger">
              Please select a service type
            </div>
          }
        </div>

        <!-- Commission % — shown for PAYMENT or BOTH -->
        @if (newPartner.services === 'PAYMENT' || newPartner.services === 'BOTH') {
          <div class="col-md-6 mt-3"
            >
            <div class="form-group">
              <label class="required">Commission %</label>
              <input type="number" class="form-control" name="cmsn" #commision="ngModel"
                [(ngModel)]="newPartner.commission"
                min="0" max="100" step="0.01"
                placeholder="0.00"
                required>
            </div>
            @if (commision.touched && commision.invalid) {
              <div class="text-danger">
                Please enter the commission
              </div>
            }
          </div>
        }

        <!-- Remittance Commission % — shown for REMITTANCE or BOTH -->
        @if (newPartner.services === 'REMITTANCE' || newPartner.services === 'BOTH') {
          <div class="col-md-6 mt-3"
            >
            <div class="form-group">
              <label class="required">Remittance Commission %</label>
              <input type="number" class="form-control" name="remittanceCommission"
                #remittanceCommission="ngModel"
                [(ngModel)]="newPartner.remittanceCommission"
                min="0" max="100" step="0.01"
                placeholder="0.00"
                required>
            </div>
            @if (remittanceCommission.touched && remittanceCommission.invalid) {
              <div class="text-danger">
                Please enter the remittance commission
              </div>
            }
          </div>
        }

        <!-- Account Number -->
        <div class="col-md-6 mt-3">
          <div class="form-group">
            <label class="required">Account Number</label>
            <input type="text" class="form-control" required name="accNo" #accNum="ngModel"
              [(ngModel)]="newPartner.accountNumber" required>
          </div>
          @if (accNum.touched && accNum.invalid) {
            <div class="text-danger">
              Please enter the account number
            </div>
          }
        </div>

        <!-- Routing Number -->
        <div class="col-md-6 mt-3">
          <div class="form-group">
            <label class="required">Routing Number</label>
            <input type="text" class="form-control" required name="routNo" #routNum="ngModel"
              [(ngModel)]="newPartner.routingNumber" required>
          </div>
          @if (routNum.touched && routNum.invalid) {
            <div class="text-danger">
              Please enter the routing number
            </div>
          }
        </div>

        <!-- Branch -->
        <div class="col-md-6 mt-3">
          <div class="form-group">
            <label class="required">Branch</label>
            <input type="text" class="form-control" required name="brnch" #brch="ngModel"
              [(ngModel)]="newPartner.branch" required>
          </div>
          @if (brch.touched && brch.invalid) {
            <div class="text-danger">
              Please enter the branch
            </div>
          }
        </div>

        <!-- Logo URL -->
        <div class="col-md-6 mt-3">
          <div class="form-group">
            <label class="required">Logo URL</label>
            <div class="input-group">
              <input type="text" class="form-control" name="logoPath" #logoPath="ngModel"
                [(ngModel)]="newPartner.logoPath"
                placeholder="https://..."
                required>
              @if (newPartner.logoPath) {
                <span class="input-group-text p-1">
                  <img [src]="newPartner.logoPath" style="height:28px; object-fit:contain;" alt="logo preview">
                </span>
              }
            </div>
            @if (logoPath.touched && logoPath.invalid) {
              <div class="text-danger">
                Please enter the logo URL
              </div>
            }
          </div>
        </div>

        <!-- Status -->
        <div class="col-md-6 mt-3">
          <div class="form-group">
            <label class="required">Status</label>
            <select class="form-control form-select" #status="ngModel" name="status"
              [(ngModel)]="newPartner.status" required>
              <option value="Active">Active</option>
              <option value="InActive">InActive</option>
            </select>
          </div>
          @if (status.touched && status.invalid) {
            <div class="text-danger">
              Please select status
            </div>
          }
        </div>

        <!-- Enable Refund / Dispute -->
        <div class="col-md-6 mt-3">
          <div class="form-group d-flex gap-4 mt-2">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="isRefundEnabled"
                [(ngModel)]="newPartner.isRefundEnabled" name="isRefundEnabled">
              <label class="form-check-label" for="isRefundEnabled">
                Enable Refund
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="isDisputeEnabled"
                [(ngModel)]="newPartner.isDisputeEnabled" name="isDisputeEnabled">
              <label class="form-check-label" for="isDisputeEnabled">
                Enable Dispute
              </label>
            </div>
          </div>
        </div>

        <!-- Origination Country -->
        <div class="col-md-12 mt-3">
          <div class="form-group">
            <label class="required">Origination Country</label>
            <select class="form-control form-select" name="originationCountry" #originationCountry="ngModel"
              [(ngModel)]="newPartner.originationCountryId" required>
              <option value="">Select Origination Country</option>
              @for (country of countries; track country) {
                <option [value]="country._id">
                  {{ country.displayName || country.name }}
                </option>
              }
            </select>
          </div>
          @if (originationCountry?.touched && originationCountry?.invalid) {
            <div class="text-danger">
              Please select an origination country
            </div>
          }
        </div>



      </div>

      <div class="row">
        <div class="col-md-12 mt-4 text-center">
          <button [disabled]="!partnerForm.valid" class="btn btn-primary active mt-4 w-50"
          (click)="onSubmit(partnerForm)">Submit</button>
        </div>
      </div>
    </div>
  </form>
</div>
